<template>
  <modal name="signUpTos" v-bind:width="400" v-bind:height="572"
         v-on:before-open="beforeOpen">
    <div class="signUpTosWrapper">
      <div class="signUpTosTop">
        <img v-bind:src="closeIcon" v-on:click="modalClose">
      </div>
      <div class="signUpTosHeader">
        <span>상세보기</span>
      </div>
      <div class="signUpTosContentWrapper">
        <div class="signUpTosItemNameDiv">
          <span class="itemName">{{optionName}}</span>
        </div>
        <div class="signUpTosDiv">
          <span v-html="signUpTosText"></span>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import params from '../../../params'

export default {
  data () {
    return {
      closeIcon: null,
      index: null,
      optionName: null,
      signUpTosText: null
    }
  },
  methods: {
    modalClose: function () {
      this.$modal.hide('signUpTos')
    },
    beforeOpen: function (event) {
      this.index = event.params.index
      this.optionName = event.params.optionName
      this.signUpTosText = params.signUpTosText[this.index].text
    }
  },
  created: function () {
    this.closeIcon = require('@/assets/img/modal_close_icon.png')
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.signUpTosWrapper {
  display : -webkit-flex;
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0;
}

.signUpTosTop {
  display : -webkit-flex;
  display: flex;
  justify-content: flex-end;
  height: 32px;
  padding-top: 12px;
  padding-right: 12px;
}

.signUpTosTop > img {
  cursor: pointer;
  height: 100%;
  width: auto;
}

.signUpTosHeader {
  display : -webkit-flex;
  display: flex;
  flex-direction: column;
  padding: 0 32px;
  font-size: 24px;
}

.signUpTosContentWrapper{
  display : -webkit-flex;
  display: flex;
  flex-direction: column;
  padding: 0 32px;
}

.signUpTosItemNameDiv {
  margin-top: 14px;
}

.itemName {
  font-size: 11px;
  color: rgb(0,153,255);
}

.signUpTosDiv {
  height: 365px;
  width: calc(100% - 36px);
  border: 1px black solid;
  margin-top: 16px;
  padding: 18px;
  font-size: 11px;
  overflow-y: auto;
}

.signUpTosDiv::-webkit-scrollbar {
  width: 12px;
}
.signUpTosDiv::-webkit-scrollbar-thumb {
  background-color: #000000;
}
.signUpTosDiv::-webkit-scrollbar-track {
  background-color: #EFEFEF;
}
</style>



// WEBPACK FOOTER //
// src/components/login/elements/signUpTosModal.vue